import { Component, inject } from '@angular/core';
import { ProfilebannerComponent } from '../profilebanner/profilebanner.component';
import { CommonModule } from '@angular/common';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faHeart, faSmile, faEnvelope, faFlag } from '@fortawesome/free-solid-svg-icons';
import { ProfileIconsComponent } from '../profile-icons/profile-icons.component';
import { ProfileTabComponent } from '../profile-tab/profile-tab.component';
import { ViewPhotosComponent } from "../view-photos/view-photos.component";
import { FriendsTabComponent } from "../friends-tab/friends-tab.component";
import { SuggestionUserComponent } from "../suggestion-user/suggestion-user.component";
import { OnlineMemberComponent } from "../online-member/online-member.component";
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ApiServicesService } from '../services/api-services.service';
import { SnackbarService } from '../services/snackbar.service';
import { UserDetailsService } from '../services/user-details.service';
import { ServicesService } from '../my-profile/services.service';
import { ViewDetailsComponent } from "../view-details/view-details.component";
import { Subject, Subscription } from 'rxjs';
import { takeUntil, filter } from 'rxjs/operators';

@Component({
  selector: 'app-member-profile',
  standalone: true,
  imports: [ProfilebannerComponent, CommonModule, FontAwesomeModule, ProfileTabComponent, ViewPhotosComponent, FriendsTabComponent, SuggestionUserComponent, OnlineMemberComponent, ViewDetailsComponent],
  templateUrl: './member-profile.component.html',
  styleUrl: './member-profile.component.css'
})

export class MemberProfileComponent {

  activeTab: string = "";
  is_show_menu_tab: boolean = false;
  total_notification: number = 5;
  faheart = faHeart;
  fasmile = faSmile;
  faenvelop = faEnvelope;
  flag = faFlag;
  userData: any = '';
  tabName: any[] = ['Profile', 'Media', 'Friends'];
  is_myProfile: boolean = false;
  name: any = '';
  userId: any = '';
  loader: boolean = true;

  constructor(private route: ActivatedRoute, private apiService: ApiServicesService, private router: Router, private snackbarService: SnackbarService, private userServices: UserDetailsService,) { };

  tabChange(tabname: string) {
    this.is_show_menu_tab=false;
    this.activeTab = tabname;
    this.router.navigate(["/member-profile", this.name, this.activeTab])
  }

  private taskservices = inject(ServicesService);
  private destroy$ = new Subject<void>();

  previousUrl: any = '';
  ngOnInit() {
    this.userServices.userdetails$
      .pipe(takeUntil(this.destroy$))
      .subscribe(details => {
      });

    this.initializeRouteParams();

    this.taskservices.isView$.subscribe((value) => {
      if (value) {
        this.activeTab = value;
      }
    });

    this.router.events
      .pipe(
        takeUntil(this.destroy$),
        filter((event) => event instanceof NavigationEnd)
      )
      .subscribe((event: NavigationEnd) => {
        if (event.url.includes('member-profile')) {
          const currentUrl = event.urlAfterRedirects;
          const currentUrlSplit = currentUrl?.split("/") || [];
          const previousUrlSplit = this.previousUrl?.split("/") || [];
          if (
            currentUrlSplit.length > 2 &&
            previousUrlSplit.length > 2 &&
            currentUrlSplit[2] !== previousUrlSplit[2]
          ) {
            this.userServices.clearUserDetails();
            this.loader = true;
            this.handleNavigationToProfile();
          } else if (previousUrlSplit.length == 1) {
            this.handleNavigationToProfile();
          }
          this.previousUrl = currentUrl;
        }
      });
  }



  private initializeRouteParams(): void {
    const routeParams = this.route.snapshot.params;

    this.activeTab = this.tabName.includes(routeParams['tab'])
      ? routeParams['tab']
      : this.tabName[0];

    if (routeParams['username']) {
      this.name = routeParams['username'];
      this.userServices.Gotuserdetails('');
      this.viewOthersProfile();
    }
  }

  private handleNavigationToProfile(): void {
    this.userServices.Gotuserdetails('');
    const routeParams = this.route.snapshot.params;

    this.activeTab = this.tabName.includes(routeParams['tab'])
      ? routeParams['tab']
      : this.tabName[0];

    this.name = routeParams['username'];
    this.is_myProfile = this.apiService.checkProfile(this.name);
    if (this.is_myProfile) {
      this.router.navigate(['/my-profile', this.name, 'Profile']);
    } else {
      this.viewOthersProfile();
    }
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    this.userServices.clearUserDetails();
  }

  recordProfileView() {
    var data = { viewedId: this.userId }
    this.apiService.recordProfileView(data).subscribe({
      next: (response) => { },
      error: (error) => { 
        
      }
    })
  }

  viewOthersProfile() {
    this.loader = true;
    this.apiService.viewOthersProfile(this.name).subscribe({
      next: (response) => {
        if (response.status == 200) {
          this.userId = response?.user?._id;
          this.loader = false;
          this.userServices.Gotuserdetails(response);
          this.recordProfileView();
        } else {
          const encryptedData = localStorage.getItem('encryptedUserData');
          if (encryptedData) {
            const decryptedData = this.apiService.decryptData(encryptedData);
            this.router.navigate(['/my-profile', decryptedData.user.username, 'Profile']);
            this.snackbarService.openCustomSnackbar(
              {
                icon: false,
                message: response.message,
                className: 'failed',
              }
            );
          }
        }

        if(response.message=='Your account is inactive. Cannot perform this action.'){
          this.snackbarService.openCustomSnackbar(
            {
              icon: false,
              message: response.message,
              className: 'failed',
            }
          );
        }


      },
      error: (err) => {
        const encryptedData = localStorage.getItem('encryptedUserData');
        if (encryptedData) {
          const decryptedData = this.apiService.decryptData(encryptedData);
          if (decryptedData && decryptedData.user) {
            this.snackbarService.openCustomSnackbar(
              {
                icon: false,
                message: err.error.message,
                className: 'failed',
              }
            );
            this.router.navigate(['/my-profile', decryptedData.user.username, 'Profile']);
          }
        }
      },
    });
  }

  openMessage() {
    const encryptedData = localStorage.getItem('encryptedUserData');
    if (encryptedData) {
      const decryptedData = this.apiService.decryptData(encryptedData);
      if (decryptedData && decryptedData.user) {
        this.router.navigate(['/my-profile', decryptedData.user.username, 'Message'], { queryParams: { "receiver_id": this.userId, "username": this.name } });
      }
    }
  }

  sendMessge() {
    this.apiService.SendMsg(this.userId, "wink", "Hi There!",'').subscribe({
      next: (response) => {
        this.snackbarService.openCustomSnackbar(
          {
            icon: true,
            message: "Message send successfully",
            className: 'success',
          }
        );
      },
      error: (error) => { 
        this.snackbarService.openCustomSnackbar(
          {
            icon: false,
            message: error.error.message,
            className: 'failed',
          }
        );
      }
    })
  }

  addToFavorite() {
    var data = {
      favoriteUserId: this.userId,
    }
    this.apiService.addToFavorite(data).subscribe({
      next: (response) => {
        this.snackbarService.openCustomSnackbar(
          {
            icon: true,
            message: response.message,
            className: 'success',
          }
        );
      },
      error: (err) => {
        this.snackbarService.openCustomSnackbar(
          {
            icon: false,
            message: err.error.message,
            className: 'failed',
          }
        );
      }
    })
  }
}
